// extracted by mini-css-extract-plugin
export default {"title":"LinkedItemForm_title__5I4-F"};